import PropTypes from 'prop-types';
import { useEffect, useState, useCallback } from 'react';
import classnames from 'classnames';
import debounce from 'lodash/debounce';

import theme from 'src/styles/components/MenuSelection.module.scss';
import { useSwipeable } from 'react-swipeable';

const MenuSelection = ({
    menus,
    activeMenuId,
    setActiveCategory,
    multipleMenus,
    enableAutoUpdateMenu,
    enableAutoUpdateMenuCategory
}) => {
    const [activeMenuIndex, setActiveMenuIndex] = useState(menus.findIndex((menu) => menu.id === activeMenuId));

    const handleEnableAutoUpdateMenu = useCallback(debounce(() => {
        enableAutoUpdateMenu();
    }, 1000, []));

    const handleEnableAutoUpdateMenuCategory = useCallback(debounce(() => {
        enableAutoUpdateMenuCategory();
    }, 1000, []));

    useEffect(() => {
        setActiveMenuIndex(menus.findIndex((menu) => menu.id === activeMenuId));
    }, [activeMenuId]);

    const handleSetMenu = useCallback((id) => {
        const selectedMenu = menus.find((menu) => menu.id === id);

        setActiveCategory(selectedMenu.categories[0].id, true, true);

        handleEnableAutoUpdateMenu();
        handleEnableAutoUpdateMenuCategory();
    }, [multipleMenus]);

    const swipeHandlers = useSwipeable({
        onSwipedUp: () => {
            if (activeMenuIndex < menus.length - 1) {
                handleSetMenu(menus[activeMenuIndex + 1].id);
            }
        },
        onSwipedDown: () => {
            if (activeMenuIndex > 0) {
                handleSetMenu(menus[activeMenuIndex - 1].id);
            }
        },
        trackTouch: true,
        trackMouse: true,
        preventDefaultTouchmoveEvent: true
    });

    return (
        <div className={theme.menuSelector} {...swipeHandlers}>
            {menus.map(({ id, name }, index) => (
                <div
                  key={index}
                  tabIndex={0}
                  role="button"
                  onClick={() => handleSetMenu(id)}
                  style={{ transform: `translateY(${(index - activeMenuIndex + 1) * 23}px)` }}
                  className={classnames(theme.menuName, {
                    [theme.active]: index === activeMenuIndex,
                    [theme.adjacent]: index === activeMenuIndex - 1 || index === activeMenuIndex + 1
                  })}
                >
                    {name}
                </div>
            ))}
        </div>
    );
};

MenuSelection.propTypes = {
    menus: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    })),
    activeMenuId: PropTypes.string,
    setActiveCategory: PropTypes.func.isRequired,
    multipleMenus: PropTypes.bool,
    enableAutoUpdateMenu: PropTypes.func.isRequired,
    enableAutoUpdateMenuCategory: PropTypes.func.isRequired
};

export default MenuSelection;
